export const messages = {
  en: {
    complaintType: {
      title: 'Complaint Type',
      add: 'Add',
      typeName: 'Type Name',
      notifyWay: 'Notification Method',
      sms: 'SMS',
      wechat: 'WeChat',
      wechatWorkLicense: 'WeChat + Work License',
      appraiseReply: 'Evaluation Reply',
      autoReply: 'Auto Reply',
      manualReply: 'Manual Reply',
      handler: 'Handler',
      createTime: 'Create Time',
      fetchError: 'Failed to fetch complaint types'
    },
    deleteComplaintType: {
      confirmTitle: 'Confirm Operation',
      confirmText: 'Are you sure to delete this complaint type?',
      confirm: 'Confirm Delete',
      cancel: 'Cancel',
      success: 'Delete successfully',
      error: 'Delete failed'
    }
  },
  zh: {
    complaintType: {
      title: '码上说类型',
      add: '添加',
      typeName: '类型名称',
      notifyWay: '通知方式',
      sms: '短信',
      wechat: '微信',
      wechatWorkLicense: '微信+员工工牌',
      appraiseReply: '评价回复',
      autoReply: '自动回复',
      manualReply: '人工回复',
      handler: '处理人',
      createTime: '创建时间',
      fetchError: '获取码上说类型失败'
    },
    deleteComplaintType: {
      confirmTitle: '请确认您的操作',
      confirmText: '确定删除码上说类型',
      confirm: '确认删除',
      cancel: '点错了',
      success: '删除成功',
      error: '删除失败'
    }
  }
}